/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Bank = {
  properties: {
    code: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
      isRequired: true,
    },
    image: {
      type: 'string',
    },
  },
} as const;
